export default __webpack_public_path__ + "static/media/faq.66afadda.png";